export default "__VITE_ASSET__DhqBYaBw__"